export default __webpack_public_path__ + "assets/07a91fa26b6b8cdee36045de199fe9ca.svg";